import { CircularProgress, Typography, styled } from '@mui/material'
import { t } from '$i18n'
import { toLocale } from '$func/text'
import { StoryUploadStatus } from '$logic/story/types'
import { blackToTransparentGradient } from '$setup/style/helpers'

export function StatusBar({
  uploadingPercent = 0,
  compressionPercent = 0,
  uploadStatus,
}: {
  uploadingPercent?: number
  compressionPercent?: number
  uploadStatus?: StoryUploadStatus
}) {
  if (!uploadStatus) return null
  return (
    <Root>
      <Typography color="inherit" variant="subtitle3">
        <>
          {uploadStatus === 'COMPRESSING' ? (
            <>
              {t('chat.compressing')}
              <Progress percent={compressionPercent} />
            </>
          ) : uploadStatus === 'UPLOADING' ? (
            <>
              {t('story.createStoryModal.uploading')}
              <Progress percent={uploadingPercent} />
            </>
          ) : uploadStatus === 'SENDING' ? (
            t('story.sending')
          ) : (
            ''
          )}
        </>
      </Typography>
      <CircularProgress sx={{ color: 'neutral000' }} size={17} />
    </Root>
  )
}

const Root = styled('div')`
  position: absolute;
  bottom: 0;
  right: 0;
  padding: 18px 12px;
  display: flex;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
  z-index: 2;
  color: ${({ theme }) => theme.palette.neutral000};
  height: 56px;
  background: ${blackToTransparentGradient('top')};
  gap: 8px;
  box-sizing: border-box;
`

const Progress = ({ percent }: { percent?: number }) => {
  if (percent)
    return (
      <Typography
        variant="inherit"
        sx={{ display: 'inline-block', mr: '3px' }}
        width="30px"
        color="inherit"
        component="span"
      >
        {toLocale(percent)}%
      </Typography>
    )
  return null
}
